import FAQ from '@/components/FAQ';

export default function FAQPage() {
  return <FAQ />;
}
